/**
 * @generated SignedSource<<06c1e70aaee91600f7510da89f350422>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type XeroSignupContainer_viewer$data = {
  readonly id: string;
  readonly actualPersonId: string | null;
  readonly " $fragmentType": "XeroSignupContainer_viewer";
};
export type XeroSignupContainer_viewer$key = {
  readonly " $data"?: XeroSignupContainer_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"XeroSignupContainer_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "XeroSignupContainer_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actualPersonId",
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "16a44da6d34762482e609e341a010130";

export default node;
